(() => {
  let countRequest = 0;
  async function refreshCount() {
    const request = ++countRequest;
    try {
      const response = await fetch(window.routes.cart_url + '.js', {cache:'no-store'});
      if (!response.ok) return;
      const cart = await response.json();
      if (request !== countRequest) return;
      document.querySelectorAll('[data-lp-cart-count]').forEach(el => {
        el.textContent = cart.item_count;
        el.hidden = !cart.item_count;
      });
    } catch {}
  }
  document.addEventListener('change', event => {
    const select = event.target.closest('[data-lpc-variant]');
    if (!select) return;
    const option = select.selectedOptions[0];
    const card = select.closest('.lpc');
    const quantity = card.querySelector('[name="quantity"]');
    if (quantity) quantity.value = option.dataset.min || 1;
    if (option.dataset.price) card.querySelector('[data-lpc-price]').textContent = option.dataset.price;
  });
  document.addEventListener('lp:cart-added', event => {
    const form = event.target;
    const button = form.querySelector('[type="submit"]');
    const label = button?.querySelector('span');
    if (!button || !label) return;
    const original = label.textContent;
    label.textContent = window.libasepkStrings.added;
    button.classList.add('lp-added');
    const feedback = form.querySelector('[data-lp-add-feedback]');
    if (feedback) feedback.textContent = window.libasepkStrings.added;
    clearTimeout(form.lpAddedTimer);
    form.lpAddedTimer = setTimeout(() => {
      button.classList.remove('lp-added');
      if (!button.disabled) label.textContent = original;
      if (feedback) feedback.textContent = '';
    }, 1800);
    refreshCount();
  });
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-lp-open-cart]');
    const drawer = document.querySelector('cart-drawer');
    if (trigger && drawer && typeof drawer.open === 'function') {
      event.preventDefault();
      drawer.open(trigger);
    }
  });
  function initChat(scope = document) {
    scope.querySelectorAll('[data-lp-chat]').forEach(chat => {
      if (chat.dataset.ready) return;
      chat.dataset.ready = 'true';
      const trigger = chat.querySelector('[data-lp-chat-toggle]');
      const panel = chat.querySelector('.lp-chat__panel');
      const closeButton = chat.querySelector('[data-lp-chat-close]');
      function close(restoreFocus = false) {
        panel.hidden = true;
        trigger.setAttribute('aria-expanded','false');
        if (restoreFocus) trigger.focus();
      }
      trigger.addEventListener('click', () => {
        const opening = panel.hidden;
        panel.hidden = !opening;
        trigger.setAttribute('aria-expanded',String(opening));
        if (opening) closeButton.focus();
      });
      closeButton.addEventListener('click', () => close(true));
      document.addEventListener('keydown', e => {
        if (e.key === 'Escape' && !panel.hidden) close(true);
      });
      document.addEventListener('pointerdown', e => {
        if (!panel.hidden && !chat.contains(e.target)) close();
      });
      chat.addEventListener('focusout', () => {
        setTimeout(() => {
          if (!panel.hidden && !chat.contains(document.activeElement)) close();
        });
      });
    });
  }
  function init() {
    initChat();
    if (typeof subscribe === 'function') subscribe(PUB_SUB_EVENTS.cartUpdate, refreshCount);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
  document.addEventListener('shopify:section:load',e => initChat(e.target));
})();